<div *ngIf='(vm$ | async) as vm'>
    <app-page-header [vm]="vm" title='Web Account Application' [canGoBack]="true" [canRefresh]="true"
        (refreshClick)="refreshPage()" [notify]="notifyObj"></app-page-header>

    <div class="row center">
        <!-- stat panel -->
        <div class="col-md-12 pt-3" *ngIf="vm.statPanelVm as svm">
            <mdb-card narrower="true" cascade="true">
                <app-card-header [title]="svm.data.title" [headingSize]="3"></app-card-header>
                <mdb-card-body cascade="true">
                    <div class="row">
                        <div class="col-md-3 pb-3" *ngFor="let s of svm.data.stats">
                            <h5>
                                <strong>{{s.statName}}:</strong>
                                <small class="text-muted pl-1">{{s.intValue}}</small>
                            </h5>
                        </div>
                    </div>
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>

    <!-- Mobile -->
    <div class="d-block d-md-none">
        <div *ngIf="vm.panelsVm">
            <mdb-accordion [multiple]="false">
                <mdb-accordion-item [collapsed]="true" *ngFor="let p of vm.panelsVm; let i = index">
                    <mdb-accordion-item-head>{{p.title}}</mdb-accordion-item-head>
                    <mdb-accordion-item-body>
                        <div *ngFor="let s of p.sections">
                            <div class="container">
                                <mdb-card cascade="true" narrower="true" class="pt-3">
                                    <div class="row">
                                        <div class="col-9 col-sm-8">
                                            <div
                                                class="view view-cascade gradient-card-header blue-gradient narrower pb-0 pt-2">
                                                <h4 class="card-header-title">{{s.passengerCode}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <mdb-card-body cascade="true" class="pb-0 px-2">
                                        <mdb-card-text>
                                            <div class="row">
                                                <div class="col-5 text-right">First Name:</div>
                                                <div class="col-7"><strong>{{s.firstName}}</strong></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 text-right">Last name:</div>
                                                <div class="col-7"><strong>{{s.lastName}}</strong></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 text-right">Company:</div>
                                                <div class="col-7"><strong>{{s.companyName}}</strong></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 text-right">Email Address:</div>
                                                <div class="col-7"><strong>{{s.emailAddressPrimary}}</strong></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 text-right">Mobile Phone:</div>
                                                <div class="col-7"><strong>{{s.mobilePhoneNumber}}</strong></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 text-right">Home Phone:</div>
                                                <div class="col-7"><strong>{{s.homePhoneNumber}}</strong></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 text-right">Customer:</div>
                                                <div class="col-7"><strong>{{s.customerCode}} -
                                                        {{s.customerName}}&nbsp;&nbsp;<mdb-badge
                                                            *ngIf="s.recomendedCustomer" color="red">
                                                            {{s.recomendedCustomer}}
                                                        </mdb-badge></strong></div>
                                            </div>
                                            <div class="row">
                                                <div class="col-5 text-right">Home Address:</div>
                                                <div class="col-7"><span
                                                        *ngIf="s.homeAddressLine1 || s.homeCity || s.homePostalCode"><strong>
                                                            {{s.homeAddressLine1}} {{s.homeAddressLine2}}
                                                            {{s.homeCity}},
                                                            {{s.homeStateProvince}} {{s.homePostalCode}}
                                                        </strong></span></div>
                                            </div>
                                            <div class="row" *ngIf="s.specialInstructions">
                                                <div class="col-5 text-right">Special Instructions:</div>
                                                <div class="col-7"><strong>{{s.specialInstructions}}</strong></div>
                                            </div>
                                            <div class="row" *ngIf="s.matchPassengers">
                                                <div class="col-5 text-right">Duplicate Profiles:</div>
                                                <div class="col-7"><span><strong>
                                                            <mdb-badge color="red">{{s.matchPassengers}}</mdb-badge>
                                                        </strong></span></div>
                                            </div>
                                            <div class="row" *ngIf="s.messages">
                                                <div class="col-5 text-right">IT Recomendations:</div>
                                            </div>
                                            <div class="row" *ngIf="s.messages">
                                                <div class="col-12 text-right"><span><strong>
                                                            <mdb-badge info="true">
                                                                {{s.messages}}
                                                            </mdb-badge>
                                                        </strong></span></div>
                                            </div>
                                        </mdb-card-text>
                                    </mdb-card-body>
                                    <mdb-card-footer>
                                        <div class="row" *ngIf="s.cmdExecutedErrorText || s.completedText">
                                            <div class="col-md-12">
                                                <span *ngIf="s.cmdExecutedErrorText"
                                                    class="text-danger">{{s.cmdExecutedErrorText}}</span>
                                                <span *ngIf="s.completedText"
                                                    class="text-success">{{s.completedText}}</span>
                                            </div>
                                        </div>
                                        <div class="container">
                                            <div class="d-flex justify-content-center">
                                                <button mdbBtn color="default" type="button" outline="true"
                                                    rounded="true" size="sm" mdbWavesEffect
                                                    [disabled]="!vm.actionsAllowed"
                                                    (click)="markCompleted(vm, s.webAccountApplicationId, i)">Completed</button>
                                                <div *ngIf="s.sendWelcomeEmail">
                                                    <button mdbBtn color="dark" type="button" outline="true"
                                                        rounded="true" size="sm" mdbWavesEffect
                                                        [disabled]="!vm.actionsAllowed"
                                                        (click)="welcomeEmail(vm, s.webAccountApplicationId, i)">Welcome</button>
                                                </div>
                                                <div *ngIf="s.sendSalesTeamEmail">
                                                    <button mdbBtn color="dark" type="button" outline="true"
                                                        rounded="true" size="sm" mdbWavesEffect
                                                        [disabled]="!vm.actionsAllowed"
                                                        (click)="notifySalesTeam(vm, s.webAccountApplicationId, i)">Sales</button>
                                                </div>
                                            </div>
                                        </div>
                                    </mdb-card-footer>
                                </mdb-card>
                            </div>
                        </div>
                    </mdb-accordion-item-body>
                </mdb-accordion-item>
            </mdb-accordion>
        </div>
    </div>

    <!-- Desktop-->
    <div class="d-none d-md-block">
        <!-- tabs -->
        <div class="row pt-3">
            <div class="col-md-12">

                <mdb-tabset #staticTabs [buttonClass]="'md-tabs blue-gradient'" [contentClass]="'card'">

                    <mdb-tab *ngFor="let p of vm.panelsVm; let i = index" heading="{{p.title}}">
                        <div class="row">
                            <div class="col-md-6 animated fadeIn pb-3" *ngFor="let s of p.sections">
                                <mdb-card narrower="true" cascade="true">
                                    <app-card-header [title]="s.passengerCode" [headingSize]="4"
                                        [subTitle]="s.submitedDateTimeString" [dangerText]="">
                                    </app-card-header>
                                    <mdb-card-body cascade="true">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="table-responsive">
                                                    <table mdbTable striped="true" small="true">
                                                        <tbody>
                                                            <tr>
                                                                <td>First Name:</td>
                                                                <td style="font-weight: bold;">
                                                                    &nbsp;{{s.firstName}}
                                                                </td>
                                                                <td>Last name:</td>
                                                                <td style="font-weight: bold;">
                                                                    &nbsp;{{s.lastName}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Submited Company:</td>
                                                                <td style="font-weight: bold;">
                                                                    &nbsp;{{s.companyName}}
                                                                </td>
                                                                <td>Email Address:</td>
                                                                <td style="font-weight: bold;">
                                                                    &nbsp;{{s.emailAddressPrimary}}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Mobile Phone:</td>
                                                                <td style="font-weight: bold;">
                                                                    &nbsp;{{s.mobilePhoneNumber}}
                                                                </td>
                                                                <td>Home Phone:</td>
                                                                <td style="font-weight: bold;">
                                                                    &nbsp;{{s.homePhoneNumber}}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Customer:</td>
                                                                <td colspan="3" style="font-weight: bold;"><span
                                                                        style="font-weight: bold;">{{s.customerCode}}
                                                                        -
                                                                        {{s.customerName}}&nbsp;&nbsp;<mdb-badge
                                                                            *ngIf="s.recomendedCustomer" color="red">
                                                                            {{s.recomendedCustomer}}
                                                                        </mdb-badge></span></td>
                                                            </tr>
                                                            <tr>
                                                                <td>Home Address:</td>
                                                                <td colspan="3" style="font-weight: bold;"><span
                                                                        *ngIf="s.homeAddressLine1 || s.homeCity || s.homePostalCode">
                                                                        {{s.homeAddressLine1}}
                                                                        {{s.homeAddressLine2}}
                                                                        {{s.homeCity}},
                                                                        {{s.homeStateProvince}}
                                                                        {{s.homePostalCode}}
                                                                    </span></td>
                                                            </tr>
                                                            <tr *ngIf="s.specialInstructions">
                                                                <td>Special Instructions:</td>
                                                                <td colspan="3" style="font-weight: bold;">
                                                                    <span>{{s.specialInstructions}}</span>
                                                                </td>
                                                            </tr>
                                                            <tr *ngIf="s.matchPassengers">
                                                                <td>Duplicate Profiles:</td>
                                                                <td colspan="3" style="font-weight: bold;"><span
                                                                        style="font-weight: bold;">
                                                                        <mdb-badge color="red">
                                                                            {{s.matchPassengers}}
                                                                        </mdb-badge>
                                                                    </span></td>
                                                            </tr>
                                                            <tr *ngIf="s.messages">
                                                                <td>IT Recomendations:</td>
                                                                <td colspan="3" style="font-weight: bold;"><span
                                                                        style="font-weight: bold;">
                                                                        <mdb-badge info="true">
                                                                            <h6>{{s.messages}}</h6>
                                                                        </mdb-badge>
                                                                    </span></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </mdb-card-body>
                                    <mdb-card-footer>
                                        <div class="row" *ngIf="s.cmdExecutedErrorText || s.completedText">
                                            <div class="col-md-12">
                                                <span *ngIf="s.cmdExecutedErrorText"
                                                    class="text-danger">{{s.cmdExecutedErrorText}}</span>
                                                <span *ngIf="s.completedText"
                                                    class="text-success">{{s.completedText}}</span>
                                            </div>
                                        </div>
                                        <div class="container">
                                            <div class="d-flex justify-content-center">
                                                <div *ngIf="s.applicationStatus != 2">
                                                    <button mdbBtn color="default" type="button" outline="true"
                                                        rounded="true" size="sm" mdbWavesEffect
                                                        [disabled]="!vm.actionsAllowed"
                                                        (click)="markCompleted(vm, s.webAccountApplicationId, i)">Completed</button>
                                                </div>
                                                <div *ngIf="s.sendWelcomeEmail">
                                                    <button mdbBtn color="dark" type="button" outline="true"
                                                        rounded="true" size="sm" mdbWavesEffect
                                                        [disabled]="!vm.actionsAllowed"
                                                        (click)="welcomeEmail(vm, s.webAccountApplicationId, i)">Welcome
                                                        Email</button>
                                                </div>
                                                <div *ngIf="s.sendSalesTeamEmail">
                                                    <button mdbBtn color="dark" type="button" outline="true"
                                                        rounded="true" size="sm" mdbWavesEffect
                                                        [disabled]="!vm.actionsAllowed"
                                                        (click)="notifySalesTeam(vm, s.webAccountApplicationId, i)">Notify
                                                        Sales Team</button>
                                                </div>
                                            </div>
                                        </div>
                                    </mdb-card-footer>
                                </mdb-card>
                            </div>
                        </div>
                    </mdb-tab>
                </mdb-tabset>
            </div>
        </div>
    </div>
</div>